import React from "react";
import { ModeRendererProps } from "./types";

export function VasarelyKandinskyMode({ brand }: ModeRendererProps) {
  // Disciplined color logic with dynamic compositions
  // Circles and lines with tonal hierarchies and movement cues
  
  return (
    <g>
      <rect x="0" y="0" width="794" height="1123" fill={brand.paper} />
      
      {/* Large dominant circle - Kandinsky style */}
      <circle cx="250" cy="250" r="140" fill={brand.violet} opacity={0.7} />
      
      {/* Vasarely concentric rings on main circle */}
      {Array.from({ length: 10 }).map((_, i) => {
        const r = 130 - i * 13;
        return (
          <circle
            key={`main-ring-${i}`}
            cx="250"
            cy="250"
            r={r}
            fill="none"
            stroke={i % 2 === 0 ? brand.aqua : brand.amber}
            strokeWidth="2"
            opacity={0.8 - i * 0.05}
          />
        );
      })}
      
      {/* Secondary circles with movement */}
      <circle cx="520" cy="180" r="80" fill={brand.aqua} opacity={0.6} />
      <circle cx="600" cy="320" r="60" fill={brand.amber} opacity={0.7} />
      <circle cx="450" cy="380" r="50" fill={brand.deep} opacity={0.8} />
      
      {/* Optical rings on secondary circles */}
      {Array.from({ length: 6 }).map((_, i) => (
        <circle
          key={`sec-ring-${i}`}
          cx="520"
          cy="180"
          r={70 - i * 11}
          fill="none"
          stroke={brand.deep}
          strokeWidth="1.5"
          opacity={0.5}
        />
      ))}
      
      {/* Dynamic lines suggesting movement */}
      <line x1="80" y1="150" x2="650" y2="450" stroke={brand.violet} strokeWidth="4" opacity={0.3} />
      <line x1="150" y1="80" x2="500" y2="500" stroke={brand.aqua} strokeWidth="3" opacity={0.3} />
      <line x1="700" y1="100" x2="300" y2="400" stroke={brand.amber} strokeWidth="3" opacity={0.3} />
      
      {/* Middle section - circles in hierarchy */}
      <circle cx="150" cy="580" r="90" fill={brand.amber} opacity={0.7} />
      <circle cx="350" cy="620" r="70" fill={brand.violet} opacity={0.6} />
      <circle cx="520" cy="600" r="85" fill={brand.aqua} opacity={0.65} />
      
      {/* Concentric optical effects */}
      {Array.from({ length: 7 }).map((_, i) => (
        <circle
          key={`mid-ring-${i}`}
          cx="350"
          cy="620"
          r={60 - i * 8}
          fill="none"
          stroke={i % 2 === 0 ? brand.white : brand.deep}
          strokeWidth="2"
          opacity={0.6}
        />
      ))}
      
      {/* Small circles creating rhythm */}
      {Array.from({ length: 15 }).map((_, i) => {
        const angle = (i * Math.PI * 2) / 15;
        const cx = 350 + Math.cos(angle) * 180;
        const cy = 620 + Math.sin(angle) * 180;
        const r = 15 + (i % 3) * 8;
        const colors = [brand.aqua, brand.violet, brand.amber];
        
        return (
          <circle
            key={`rhythm-${i}`}
            cx={cx}
            cy={cy}
            r={r}
            fill={colors[i % 3]}
            opacity={0.5}
          />
        );
      })}
      
      {/* Bottom section - structured field with circles */}
      {Array.from({ length: 4 }).map((_, row) =>
        Array.from({ length: 6 }).map((_, col) => {
          const cx = 100 + col * 110;
          const cy = 820 + row * 80;
          const r = 25 + (row * col) % 15;
          const colors = [brand.violet, brand.aqua, brand.amber, brand.deep];
          
          return (
            <g key={`grid-circle-${row}-${col}`}>
              <circle cx={cx} cy={cy} r={r} fill={colors[(row + col) % 4]} opacity={0.6} />
              {Array.from({ length: 3 }).map((_, i) => (
                <circle
                  key={`inner-${i}`}
                  cx={cx}
                  cy={cy}
                  r={r - 5 - i * 6}
                  fill="none"
                  stroke={brand.white}
                  strokeWidth="1"
                  opacity={0.4}
                />
              ))}
            </g>
          );
        })
      )}
      
      {/* Connecting lines suggesting flow */}
      {Array.from({ length: 5 }).map((_, i) => (
        <line
          key={`flow-${i}`}
          x1={100 + i * 110}
          y1="820"
          x2={210 + i * 110}
          y2="1060"
          stroke={brand.violet}
          strokeWidth="2"
          opacity={0.2}
          strokeDasharray="5,5"
        />
      ))}
    </g>
  );
}
